import { User } from '@builddocs/data-management'

import { CryptoproCertificate } from '../lib/cryptopro/types'

/**
 * Нормализует строку для сравнения (убирает пробелы, приводит к нижнему регистру)
 */
const normalizeString = (str: string | undefined): string => {
  if (!str) return ''
  return str.trim().toLowerCase()
}

/**
 * Проверяет, совпадает ли ФИО пользователя с ФИО в сертификате
 * @param user - данные пользователя
 * @param certificate - данные сертификата
 * @returns объект с результатом проверки и сообщением об ошибке
 */
export const isUserMatchesCertificate = (
  user: User | undefined,
  certificate: CryptoproCertificate | undefined,
): { isValid: boolean; errorMessage?: string } => {
  // Если сертификат не выбран
  if (!certificate) {
    return { isValid: true }
  }

  // Если пользователь не указан
  if (!user) {
    return {
      isValid: false,
      errorMessage: 'Данные пользователя не найдены',
    }
  }

  // Проверяем, что ФИО в аккаунте заполнено
  if (!user.lastName || !user.firstName) {
    return {
      isValid: false,
      errorMessage: 'ФИО в аккаунте не заполнено',
    }
  }

  const certLastName = normalizeString(certificate.Subject?.SN)

  const certFirstAndMiddleName = normalizeString(certificate.Subject?.G)

  const userLastName = normalizeString(user.lastName)

  const userFirstAndMiddleName = normalizeString(
    [user.firstName, user.middleName]
      .map(s => normalizeString(s))
      .filter(Boolean)
      .join(' '),
  )

  const errorText =
    'Невозможно подписать документ: ФИО в сертификате не совпадает с ФИО в личном кабинете. Пожалуйста, измените ФИО в личном кабинете так, чтобы оно полностью соответствовало ФИО в вашем сертификате.'

  if (certLastName !== userLastName) {
    return {
      isValid: false,
      errorMessage: errorText,
    }
  }

  if (certFirstAndMiddleName !== userFirstAndMiddleName) {
    return {
      isValid: false,
      errorMessage: errorText,
    }
  }

  return { isValid: true }
}
